export default __webpack_public_path__ + "static/3-a235f37e71e63e7cae1dd32157d334d8.jpeg";